import { createStore, compose, combineReducers } from 'redux';
//import { createStore, compose, applyMiddleware } from 'redux';
//import promiseMiddleware from 'redux-promise';

import { valor } from '../reducers/valor';
import { auth } from '../reducers/auth';

import { edicion } from '../reducers/edicion';

import { snackBar } from '../reducers/snackBar';
import { tipoRegistro } from '../reducers/tipoRegistro';
import { apiFetch } from '../reducers/apiFetch';
import { reducer as formReducer } from 'redux-form';

/*
estado:init -> se inicializo el formulario y esta listo para consulta 
estado:fetching -> se esta haciendo una consulta se debe mostrar la espera
estado:done -> la consulta finalizo se deben mostrar los datos
*/

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION__ || compose;

const rootReducer = combineReducers({
    valor: valor,
    form: formReducer,
    auth: auth, //auth porque debe ser igual al estado inicial.
    apiFetch: apiFetch,
    tipoRegistro: tipoRegistro,
    snackBar: snackBar,
    edicion: edicion,
});

const initialState = {
    //terceroID: '',
    valor: '',
    auth: { loggedIn: false, nombre: '', telefono: '', usuarioInt: '', email: '' },
  
    apiFetch: {},
    tipoRegistro: '',
    //dia: '',
    snackBar: { open: false, mensaje: '', autoClose: true, autoCloseTime: 2750 },
    edicion: { providencia: {} },
};

export const store = createStore(rootReducer, initialState, composeEnhancers());
//export let store = createStore(reducers, {}, composeEnhancers(applyMiddleware(promiseMiddleware())));